
import React, { useState, useEffect } from 'react';

import { ChevronDown } from 'lucide-react';
import { FormGroup, Label, Input, DropdownMenu, DropdownMenuTrigger, Button, DropdownMenuContent, DropdownMenuItem } from 'twyne-new.ui';
import { isEmail } from 'validator';

import SelectTimeZone from 'components/form/SelectTimeZoneInput';

const searchTypes = {
  email: 'E-mail',
  phone: 'Phone',
}

export default function Header({ data, onSearch }) {
  const [type, setType] = useState('email')
  const [value, setValue] = useState('')
  const [timezone, setTimezone] = useState(null)
  const [emailInvalid, setEmailInvalid] = useState(false)

  useEffect(() => {
    if (searchTypes[data.key] && data.value) {
      setType(data.key)
      setValue(data.value)
    }
  }, [data.key, data.value])

  useEffect(() => {
    setEmailInvalid(!value || (type === 'email' && !isEmail(value)))
  }, [value, type])

  const handleChangeType = key => {
    setType(key)
    setValue('')
  }

  const handleSearch = () => {
    onSearch({
      key: type,
      value,
      timeZone: timezone,
    })
  }

  return <>
    <div className='flex items-center gap-4 max-md:flex-col max-md:items-stretch'>
      <div className='w-[50%] max-md:w-full'>
        <FormGroup>
          <Label>Search</Label>
          <div className='flex items-center'>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant='light' className='rounded-r-none'>
                  {searchTypes[type]}
                  <ChevronDown size='14' />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {Object.entries(searchTypes).map(([key, label]) => <DropdownMenuItem key={key} onClick={() => handleChangeType(key)}>{label}</DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>
            <Input
              className='rounded-l-none'
              type="text"
              placeholder={`Enter ${type}`}
              value={value}
              onChange={e => setValue(e.target.value)}
            />
          </div>
        </FormGroup>
      </div>
      <div className='w-[45%] max-md:w-full'>
        <FormGroup>
          <Label>Timezone</Label>
          <SelectTimeZone
            placeholder="Organizations timezone"
            value={timezone}
            onChange={opt => setTimezone(opt ? opt.value : null)}
          />
        </FormGroup>
      </div>
      <div className='w-[5%] flex justify-end max-md:w-full'>
        <Button disabled={emailInvalid || !value} className='mt-5 max-md:mt-0 max-md:w-full max-md:justify-center' color='accent' onClick={() => handleSearch(value)}>
          Search
        </Button>
      </div>
    </div>
    <div>
      {value && emailInvalid ? <div className='twy-text-danger font-semi invalid-email'>Please enter a valid email.</div> : null}
    </div>
  </>
}

